import { isObject } from "@next-core/utils/general";
let computed = new WeakSet();

// The computed (or transformed) result should never be *computed* again.
// So does the fetched data from a remote api.
export function markAsComputed(value) {
  if (isObject(value)) {
    if (!hasBeenComputed(value)) {
      computed.add(value);
      if (Array.isArray(value)) {
        value.forEach(markAsComputed);
      } else {
        // Only mark pure objects.
        const proto = Object.getPrototypeOf(value);
        if (!proto || proto.constructor === Object) {
          Object.values(value).forEach(markAsComputed);
        }
      }
    }
  }
}
export function hasBeenComputed(object) {
  return computed.has(object);
}
export function resetAllComputedMarks() {
  computed = new WeakSet();
}
//# sourceMappingURL=markAsComputed.js.map